// extracted by mini-css-extract-plugin
export default {"label":"styles_label__b7AG5","necessityIndicator":"styles_necessityIndicator__c4nS9"};